module.exports = __webpack_public_path__ + "img/20190812162327656.938c38ef.png";